import React from "react"

import { IconErrorLarge, spacing } from "@izettle/otto"
import { Button, Dialog, DialogSize, Text } from "@izettle/react"
import { useLocalization } from "@izettle/tenko-react"

export type ErrorDialogMessageProps = {
  message: string
  title?: string
}

export default function ErrorDialog({
  onClose,
  message,
  title,
}: {
  onClose: () => void
  message: string
  title?: string
}) {
  const { text } = useLocalization()
  return (
    <Dialog
      size={DialogSize.Small}
      id="alert"
      textLabel=""
      textCloseDialog="close"
      onClose={onClose}
      svgIcon={IconErrorLarge}
      isVisible={!!message}
    >
      {title && (
        <Text.Title2 style={{ textAlign: "center", marginTop: 0 }}>
          {text(title)}
        </Text.Title2>
      )}
      <Text.Regular style={{ textAlign: "center", marginBottom: spacing.large }}>
        {text(message)}
      </Text.Regular>
      <Button fullWidth onClick={onClose}>
        {text("SIGNUP_OK")}
      </Button>
    </Dialog>
  )
}
